var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            top: "100px",
            width: "800px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
            title: "页面配置",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                "label-width": "150px",
                model: _vm.form,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "页面名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写页面名称" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("禁用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "启用客户" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth mr20",
                      attrs: {
                        placeholder: "请选择",
                        filterable: "",
                        remote: "",
                        "remote-method": _vm.companyappMethod,
                        size: "small",
                        clearable: "",
                        "value-key": "id",
                      },
                      model: {
                        value: _vm.form.appIdObj,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "appIdObj", $$v)
                        },
                        expression: "form.appIdObj",
                      },
                    },
                    _vm._l(_vm.companyapp, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.appName, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.radio1 === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "关联客户" } },
                    [
                      _c(
                        "el-select",
                        [
                          _c("el-option", {
                            attrs: { label: "默认", value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "默认", value: 2 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "默认", value: 3 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.radio1 === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "关联套餐", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请填写" },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handerSubmit } },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("go")
                    },
                  },
                },
                [_vm._v("保存并去装修")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.close } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }